var map = {
	"./aito.webp": 55006,
	"./arcfox.webp": 8720,
	"./audi.webp": 33172,
	"./baic.webp": 98476,
	"./belgee.webp": 1259,
	"./bmw.webp": 30625,
	"./byd.webp": 92416,
	"./cadillac.webp": 52234,
	"./changan.webp": 68249,
	"./chery.webp": 1152,
	"./chevrolet.webp": 54759,
	"./citroen.webp": 76211,
	"./datsun.webp": 67232,
	"./dodge.webp": 91264,
	"./dongfeng.webp": 85561,
	"./evolute.webp": 60655,
	"./exeed.webp": 64346,
	"./faw.webp": 30705,
	"./fiat.webp": 33697,
	"./ford.webp": 18428,
	"./forthing.webp": 35644,
	"./gac trumpchi.webp": 49740,
	"./gac.webp": 26150,
	"./geely.webp": 55115,
	"./genesis.webp": 92709,
	"./great wall.webp": 12950,
	"./greatwall.webp": 13490,
	"./haima.webp": 55015,
	"./haima2.webp": 94103,
	"./haval.webp": 59069,
	"./honda.webp": 6445,
	"./hongqi.webp": 31125,
	"./hyundai.webp": 92629,
	"./infiniti.webp": 99133,
	"./jac.webp": 66313,
	"./jaecoo.webp": 75994,
	"./jeep.webp": 45345,
	"./jetour.webp": 24590,
	"./jetta.webp": 89123,
	"./jmc.webp": 40093,
	"./kaiyi.webp": 44642,
	"./kia.webp": 92944,
	"./lada (ваз).webp": 10147,
	"./lada.webp": 26665,
	"./land rover.webp": 19328,
	"./leapmotor.webp": 35008,
	"./lexus.webp": 46714,
	"./lifan.webp": 66623,
	"./livan.webp": 29711,
	"./lixiang.webp": 10087,
	"./lynk&co.webp": 81279,
	"./m-hero.webp": 91547,
	"./mazda.webp": 85308,
	"./mercedes-benz.webp": 81925,
	"./mg.webp": 86105,
	"./mini.webp": 77518,
	"./mitsubishi.webp": 32150,
	"./moskvich.webp": 7973,
	"./nissan.webp": 42181,
	"./omoda.webp": 39861,
	"./opel.webp": 41819,
	"./ora.webp": 62823,
	"./oting.webp": 81662,
	"./peugeot.webp": 2002,
	"./porsche.webp": 99259,
	"./renault.webp": 97268,
	"./rising.webp": 64331,
	"./seat.webp": 39368,
	"./skoda.webp": 53363,
	"./skywell.webp": 31390,
	"./solaris.webp": 11302,
	"./sollers.webp": 41857,
	"./soueast.webp": 39055,
	"./ssangyong.webp": 48402,
	"./subaru.webp": 15833,
	"./suzuki.webp": 73776,
	"./swm.webp": 32506,
	"./tank.webp": 68077,
	"./tesla.webp": 85372,
	"./toyota.webp": 79511,
	"./uaz.webp": 56827,
	"./venucia.webp": 1796,
	"./vgv.webp": 41948,
	"./volkswagen.webp": 56074,
	"./volvo.webp": 28645,
	"./voyah.webp": 84752,
	"./voyan.webp": 48878,
	"./wey.webp": 63512,
	"./xcite.webp": 14652,
	"./zeekr.webp": 98990,
	"./zotye.webp": 96696,
	"./москвич.webp": 82063,
	"./уаз.webp": 275
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70627;